import { Swiper } from 'swiper/react';
import 'swiper/css';
import { ReactNode, useRef } from 'react';
import SliderNavCircle from 'components/Functional/Slider/SliderNavCircle';
import { SwiperOptions } from 'swiper/types';

type SliderOptions = Pick<
  SwiperOptions,
  'modules' | 'slidesPerView' | 'spaceBetween' | 'keyboard' | 'breakpoints'
>;

type Props = {
  children: ReactNode;
  className?: string;
  sliderOptions: SliderOptions;
};

const Slider = ({ children, className, sliderOptions }: Props) => {
  const navigationNextRef = useRef<HTMLButtonElement | null>(null);
  const navigationPrevRef = useRef<HTMLButtonElement | null>(null);

  return (
    <Swiper
      className={className}
      navigation={{
        prevEl: '.nav-prev',
        nextEl: '.nav-next',
      }}
      watchOverflow={true}
      {...sliderOptions}
    >
      {children}
      <div
        slot="container-start"
        className="d-flex justify-content-between align-items-center mb-6"
      >
        <SliderNavCircle
          ref={navigationPrevRef}
          aria-label="Previous slide"
          className="ms-auto nav-prev d-xl-none"
          direction="left"
        />
        <SliderNavCircle
          ref={navigationNextRef}
          aria-label="Next slide"
          className="ms-3 nav-next d-xl-none"
          direction="right"
        />
      </div>
    </Swiper>
  );
};

export default Slider;
